import { render, staticRenderFns } from "./recipe-quick-search.vue?vue&type=template&id=4b236e24&"
import script from "./recipe-quick-search.vue?vue&type=script&lang=js&"
export * from "./recipe-quick-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports